import styled from 'styled-components'
import { fadeEaseIn } from '../styles'

export const Content = styled.section`
    width: 100%;
    max-width: 100%;
    color: var(--black);
    padding: 24px;
    margin-top: 64px;
    animation-name: ${fadeEaseIn};
    animation-duration: 0.3s;
    animation-timing-function: ease-in-out;

    .ant-breadcrumb {
        margin: 8px 0 16px;
        line-height: unset !important;

        @media (max-width: 760px) {
            margin-bottom: 16px;
        }

        li {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        li, li a {
            font-size: 1rem;
            height: auto;
        }
    }

    .breadcrumb {
        h1 {
            color: var(--blue-darker);
            font-size: 1.5rem;
            margin-bottom: 24px;

            @media (max-width: 760px) {
                display: none;
            }
        }

        h2 {
            color: var(--blue-darker);
            font-size: 1.5rem;
            margin-bottom: 24px;
        }
    }
`
